var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOtherCallIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(-1167 -271)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 24,
    height: 24,
    rx: 3,
    transform: "translate(1167 271)",
    fill: "#f4f4f6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "store_FILL0_wght300_GRAD-25_opsz20",
    d: "M155.485-751.975v-1.178h13.491v1.178Zm.058,12.808v-5.245h-1.312v-1.178l1.254-4.656h13.491l1.254,4.656v1.178h-1.312v5.245h-1.178v-5.245H163.1v5.245Zm1.178-1.178h5.206v-4.067h-5.206Zm-1.289-5.245h0Zm0,0h13.6l-.917-3.478h-11.77Z",
    transform: "translate(1016.769 1029.161)",
    fill: "#3b3b3b"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOtherCallIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/otherCallIcon.1ccfe0be.svg";
export { ForwardRef as ReactComponent };